import React, { useState, useEffect } from 'react';
import api from '../services/api';

// ==================================================================================
// ÍCONES
// ==================================================================================
const Icons = {
  Building: () => (
    <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect>
      <path d="M9 6h6"></path>
      <path d="M9 10h6"></path>
      <path d="M9 14h6"></path>
      <path d="M9 18h6"></path>
    </svg>
  ),
  Plus: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <line x1="12" y1="5" x2="12" y2="19"></line>
      <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
  ),
  Upload: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="17 8 12 3 7 8"></polyline>
      <line x1="12" y1="3" x2="12" y2="15"></line>
    </svg>
  ),
  ArrowLeft: () => (
    <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <line x1="19" y1="12" x2="5" y2="12"></line>
      <polyline points="12 19 5 12 12 5"></polyline>
    </svg>
  ),
  Edit: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
  ),
  Trash: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
      <line x1="10" y1="11" x2="10" y2="17"></line>
      <line x1="14" y1="11" x2="14" y2="17"></line>
    </svg>
  ),
  Save: () => (
    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
      <polyline points="17 21 17 13 7 13 7 21"></polyline>
      <polyline points="7 3 7 8 15 8"></polyline>
    </svg>
  ),
  Globe: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="2" y1="12" x2="22" y2="12"></line>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    </svg>
  ),
  Phone: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.8 12.8 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.8 12.8 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
    </svg>
  ),
  Mail: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path d="M4 4h16v16H4z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
  ),
  MapPin: () => (
    <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  )
};

export default function Empresas() {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);

  const initialForm = {
    nome: '',
    codigoLoja: '',
    unidade: '',
    cnpj: '',
    inscricaoEstadual: '',
    endereco: '',
    telefone: '',
    whatsapp: '',
    email: '',
    linkAvaliacao: '',
    siteUrl: '',
    instagram: '',
    facebook: '',
    corPrimaria: '#0f172a',
    corSecundaria: '#4f46e5',
    focusToken: '',
    ambienteNf: 'homologacao',
    ativo: true
  };

  const [formData, setFormData] = useState(initialForm);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);

  const fetchEmpresas = async () => {
    setLoading(true);
    try {
      const response = await api.get('/empresas');
      setEmpresas(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error(err);
      alert('Erro ao carregar empresas.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmpresas();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const formatImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith('http')) return url;
    return `${api.defaults.baseURL || ''}${url}`;
  };

  const handleEdit = (emp) => {
    setEditId(emp._id);
    setFormData({
      nome: emp.nome || '',
      codigoLoja: emp.codigoLoja || '',
      unidade: emp.unidade || '',
      cnpj: emp.cnpj || '',
      inscricaoEstadual: emp.inscricaoEstadual || '',
      endereco: emp.endereco || '',
      telefone: emp.telefone || '',
      whatsapp: emp.whatsapp || '',
      email: emp.email || '',
      linkAvaliacao: emp.linkAvaliacao || '',
      siteUrl: emp.siteUrl || '',
      instagram: emp.instagram || '',
      facebook: emp.facebook || '',
      corPrimaria: emp.corPrimaria || '#0f172a',
      corSecundaria: emp.corSecundaria || '#4f46e5',
      focusToken: emp.focusToken || '',
      ambienteNf: emp.ambienteNf || 'homologacao',
      ativo: typeof emp.ativo === 'boolean' ? emp.ativo : true
    });

    setLogoFile(null);

    if (emp.logoUrl) {
      setLogoPreview(formatImageUrl(emp.logoUrl));
    } else {
      setLogoPreview(null);
    }

    setShowForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id, nome) => {
    if (!window.confirm(`Tem certeza que deseja excluir a empresa "${nome}"?`)) return;

    try {
      await api.delete(`/empresas/${id}`);
      fetchEmpresas();
    } catch (e) {
      alert(e.response?.data?.error || 'Erro ao excluir.');
    }
  };

  const resetForm = () => {
    setShowForm(false);
    setEditId(null);
    setFormData(initialForm);
    setLogoFile(null);
    setLogoPreview(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      if (logoFile) {
        data.append('logo', logoFile);
      }

      if (editId) {
        await api.put(`/empresas/${editId}`, data, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        alert('Empresa atualizada com sucesso!');
      } else {
        await api.post('/empresas', data, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        alert('Empresa cadastrada com sucesso!');
      }

      resetForm();
      fetchEmpresas();
    } catch (error) {
      alert(error.response?.data?.error || 'Erro ao salvar empresa.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="empresas-container">
      <GlobalStyles />

      <div className="header">
        <div className="header-left">
          <button onClick={() => window.history.back()} className="back-btn">
            <Icons.ArrowLeft />
          </button>

          <div>
            <h1 className="page-title">
              <Icons.Building /> Gestão de Empresas
            </h1>
            <p className="page-subtitle">
              Configure as empresas, filiais e dados institucionais do sistema.
            </p>
          </div>
        </div>

        {!showForm && (
          <button className="primary-btn" onClick={() => setShowForm(true)}>
            <Icons.Plus /> Nova Empresa
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-card">
          <div className="form-topbar">
            <h2>{editId ? 'Editar Empresa' : 'Cadastrar Nova Empresa'}</h2>
          </div>

          <form onSubmit={handleSubmit} className="form-grid">
            <div className="logo-upload-section">
              <label
                className="upload-box"
                style={logoPreview ? { backgroundImage: `url(${logoPreview})` } : {}}
              >
                {!logoPreview && (
                  <>
                    <Icons.Upload />
                    <span>Upload Logo</span>
                  </>
                )}
                <input type="file" accept="image/*" onChange={handleLogoChange} style={{ display: 'none' }} />
              </label>

              {logoPreview && (
                <button
                  type="button"
                  className="change-logo-btn"
                  onClick={() => document.querySelector('input[type="file"]')?.click()}
                >
                  Trocar Imagem
                </button>
              )}
            </div>

            <div className="inputs-section">
              <div className="section-title">Informações principais</div>

              <div className="form-row two-cols">
                <div className="input-group">
                  <label>Nome da empresa</label>
                  <input
                    required
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                    placeholder="Ex: Óticas Vizum"
                  />
                </div>

                <div className="input-group">
                  <label>Código da loja</label>
                  <input
                    required
                    type="text"
                    name="codigoLoja"
                    value={formData.codigoLoja}
                    onChange={handleInputChange}
                    placeholder="Ex: vizum-01"
                  />
                </div>
              </div>

              <div className="form-row two-cols">
                <div className="input-group">
                  <label>Unidade</label>
                  <input
                    type="text"
                    name="unidade"
                    value={formData.unidade}
                    onChange={handleInputChange}
                    placeholder="Ex: Unidade Coronel Pinto"
                  />
                </div>

                <div className="input-group">
                  <label>CNPJ</label>
                  <input
                    required
                    type="text"
                    name="cnpj"
                    value={formData.cnpj}
                    onChange={handleInputChange}
                    placeholder="00.000.000/0001-00"
                  />
                </div>
              </div>

              <div className="form-row two-cols">
                <div className="input-group">
                  <label>Inscrição Estadual</label>
                  <input
                    type="text"
                    name="inscricaoEstadual"
                    value={formData.inscricaoEstadual}
                    onChange={handleInputChange}
                    placeholder="Número ou Isento"
                  />
                </div>

                <div className="input-group">
                  <label>Ambiente NF</label>
                  <select
                    name="ambienteNf"
                    value={formData.ambienteNf}
                    onChange={handleInputChange}
                    className="custom-select"
                  >
                    <option value="homologacao">Homologação</option>
                    <option value="producao">Produção</option>
                  </select>
                </div>
              </div>

              <div className="input-group">
                <label>Endereço completo</label>
                <input
                  type="text"
                  name="endereco"
                  value={formData.endereco}
                  onChange={handleInputChange}
                  placeholder="Av. Exemplo, 123 - Bairro - Cidade/UF"
                />
              </div>

              <div className="section-title">Contato e presença online</div>

              <div className="form-row two-cols">
                <div className="input-group">
                  <label>Telefone</label>
                  <input
                    type="text"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleInputChange}
                    placeholder="(00) 0000-0000"
                  />
                </div>

                <div className="input-group">
                  <label>WhatsApp</label>
                  <input
                    type="text"
                    name="whatsapp"
                    value={formData.whatsapp}
                    onChange={handleInputChange}
                    placeholder="(00) 00000-0000"
                  />
                </div>
              </div>

              <div className="form-row two-cols">
                <div className="input-group">
                  <label>E-mail</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="contato@empresa.com"
                  />
                </div>

                <div className="input-group">
                  <label>Link de avaliação Google</label>
                  <input
                    type="text"
                    name="linkAvaliacao"
                    value={formData.linkAvaliacao}
                    onChange={handleInputChange}
                    placeholder="https://search.google.com/..."
                  />
                </div>
              </div>

              <div className="form-row two-cols">
                <div className="input-group">
                  <label>Site</label>
                  <input
                    type="text"
                    name="siteUrl"
                    value={formData.siteUrl}
                    onChange={handleInputChange}
                    placeholder="https://empresa.com.br"
                  />
                </div>

                <div className="input-group">
                  <label>Instagram</label>
                  <input
                    type="text"
                    name="instagram"
                    value={formData.instagram}
                    onChange={handleInputChange}
                    placeholder="@empresa"
                  />
                </div>
              </div>

              <div className="form-row two-cols">
                <div className="input-group">
                  <label>Facebook</label>
                  <input
                    type="text"
                    name="facebook"
                    value={formData.facebook}
                    onChange={handleInputChange}
                    placeholder="facebook.com/empresa"
                  />
                </div>

                <div className="input-group switch-block">
                  <label>Status</label>
                  <label className="switch-row-inline">
                    <input
                      type="checkbox"
                      name="ativo"
                      checked={formData.ativo}
                      onChange={handleInputChange}
                    />
                    <span>{formData.ativo ? 'Empresa ativa' : 'Empresa inativa'}</span>
                  </label>
                </div>
              </div>

              <div className="section-title">Identidade visual</div>

              <div className="form-row two-cols">
                <div className="input-group">
                  <label>Cor primária</label>
                  <div className="color-input-wrap">
                    <input
                      type="color"
                      name="corPrimaria"
                      value={formData.corPrimaria}
                      onChange={handleInputChange}
                      className="color-picker"
                    />
                    <input
                      type="text"
                      name="corPrimaria"
                      value={formData.corPrimaria}
                      onChange={handleInputChange}
                      placeholder="#0f172a"
                    />
                  </div>
                </div>

                <div className="input-group">
                  <label>Cor secundária</label>
                  <div className="color-input-wrap">
                    <input
                      type="color"
                      name="corSecundaria"
                      value={formData.corSecundaria}
                      onChange={handleInputChange}
                      className="color-picker"
                    />
                    <input
                      type="text"
                      name="corSecundaria"
                      value={formData.corSecundaria}
                      onChange={handleInputChange}
                      placeholder="#4f46e5"
                    />
                  </div>
                </div>
              </div>

              <div className="fiscal-box">
                <div className="fiscal-head">
                  <div className="dot"></div>
                  <label>Configurações fiscais</label>
                </div>

                <div className="input-group">
                  <label>Token Focus NFe</label>
                  <input
                    type="text"
                    name="focusToken"
                    value={formData.focusToken}
                    onChange={handleInputChange}
                    placeholder="Insira o token da Focus"
                    className="mono-input"
                  />
                </div>

                <p className="helper-text">
                  Esse token será usado futuramente para emissão fiscal específica da empresa.
                </p>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="cancel-btn" onClick={resetForm}>
                Descartar
              </button>

              <button type="submit" className="save-btn" disabled={saving}>
                <Icons.Save />
                {saving ? 'Processando...' : editId ? 'Salvar Alterações' : 'Finalizar Cadastro'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="empresas-grid">
          {loading ? (
            <div className="loading-state">Carregando empresas...</div>
          ) : empresas.length > 0 ? (
            empresas.map((emp) => (
              <div key={emp._id} className="empresa-card">
                <div className="card-actions">
                  <button title="Editar" onClick={() => handleEdit(emp)} className="action-btn edit">
                    <Icons.Edit />
                  </button>
                  <button title="Excluir" onClick={() => handleDelete(emp._id, emp.nome)} className="action-btn delete">
                    <Icons.Trash />
                  </button>
                </div>

                <div className="empresa-logo" style={{ borderColor: emp.corSecundaria || '#f1f5f9' }}>
                  {emp.logoUrl ? (
                    <img src={formatImageUrl(emp.logoUrl)} alt="Logo" />
                  ) : (
                    <Icons.Building />
                  )}
                </div>

                <div className="empresa-info">
                  <div className="card-topline">
                    <h3>{emp.nome}</h3>
                    <span
                      className={`badge-status ${emp.ativo ? 'on' : 'off'}`}
                      style={emp.ativo ? { background: `${emp.corSecundaria || '#4f46e5'}20`, color: emp.corSecundaria || '#4f46e5' } : {}}
                    >
                      {emp.ativo ? 'Ativa' : 'Inativa'}
                    </span>
                  </div>

                  <div className="info-row"><strong>Código:</strong> {emp.codigoLoja || '--'}</div>
                  <div className="info-row"><strong>Unidade:</strong> {emp.unidade || 'Não cadastrada'}</div>
                  <div className="info-row"><strong>CNPJ:</strong> {emp.cnpj}</div>
                  <div className="info-row"><strong>Endereço:</strong> {emp.endereco || 'Não cadastrado'}</div>

                  <div className="info-row icon-line">
                    <Icons.Phone />
                    <span>{emp.whatsapp || emp.telefone || '--'}</span>
                  </div>

                  <div className="info-row icon-line">
                    <Icons.Mail />
                    <span>{emp.email || 'Sem e-mail'}</span>
                  </div>

                  {emp.linkAvaliacao ? (
                    <div className="info-row icon-line">
                      <Icons.Globe />
                      <a href={emp.linkAvaliacao} target="_blank" rel="noreferrer">
                        Link de avaliação
                      </a>
                    </div>
                  ) : null}

                  <div className="badge-row">
                    {emp.focusToken ? (
                      <span className="badge-fiscal success">NF-e Ativada</span>
                    ) : (
                      <span className="badge-fiscal warning">Sem Token Fiscal</span>
                    )}

                    <span className="badge-ambiente">{emp.ambienteNf || 'homologacao'}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <Icons.Building />
              <p>Nenhuma empresa encontrada.</p>
              <span>Cadastre sua primeira empresa para começar a estruturar o sistema multi-loja.</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

    .empresas-container {
      max-width: 1220px;
      margin: 0 auto;
      padding: 40px 20px;
      font-family: 'Plus Jakarta Sans', sans-serif;
      color: #0f172a;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      flex-wrap: wrap;
      gap: 16px;
    }

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;
    }

    .page-title {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 26px;
      font-weight: 800;
      margin: 0 0 4px 0;
      letter-spacing: -0.5px;
    }

    .page-subtitle {
      font-size: 15px;
      color: #64748b;
      margin: 0;
      font-weight: 500;
    }

    .back-btn {
      background: #fff;
      border: 1px solid #e2e8f0;
      padding: 10px;
      border-radius: 12px;
      cursor: pointer;
      color: #475569;
      transition: 0.2s;
      display: flex;
      box-shadow: 0 2px 4px rgba(0,0,0,0.02);
    }

    .back-btn:hover {
      background: #f8fafc;
      color: #0f172a;
      border-color: #cbd5e1;
    }

    .primary-btn {
      background: #4f46e5;
      color: #fff;
      border: none;
      padding: 14px 28px;
      border-radius: 14px;
      font-weight: 700;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      transition: 0.3s;
      box-shadow: 0 10px 15px -3px rgba(79, 70, 229, 0.3);
    }

    .primary-btn:hover {
      background: #4338ca;
      transform: translateY(-2px);
      box-shadow: 0 15px 20px -3px rgba(79, 70, 229, 0.4);
    }

    .form-card {
      background: #fff;
      border-radius: 24px;
      padding: 36px;
      border: 1px solid #e2e8f0;
      box-shadow: 0 20px 25px -5px rgba(0,0,0,0.05);
      animation: slideUp 0.4s ease;
    }

    .form-topbar {
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;
    }

    .form-topbar h2 {
      font-size: 20px;
      color: #0f172a;
      font-weight: 800;
      margin: 0;
    }

    .form-grid {
      display: flex;
      gap: 36px;
      flex-wrap: wrap;
    }

    .logo-upload-section {
      width: 200px;
      text-align: center;
    }

    .upload-box {
      width: 200px;
      height: 200px;
      border: 2px dashed #cbd5e1;
      border-radius: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      cursor: pointer;
      color: #64748b;
      background-color: #f8fafc;
      background-size: cover;
      background-position: center;
      transition: 0.3s;
      position: relative;
      overflow: hidden;
    }

    .upload-box:hover {
      border-color: #4f46e5;
      color: #4f46e5;
      background-color: #f5f3ff;
    }

    .change-logo-btn {
      background: #fff;
      border: 1px solid #e2e8f0;
      padding: 8px 12px;
      border-radius: 8px;
      font-size: 11px;
      font-weight: 700;
      color: #4f46e5;
      margin-top: 12px;
      cursor: pointer;
      transition: 0.2s;
    }

    .change-logo-btn:hover {
      border-color: #4f46e5;
      background: #f5f3ff;
    }

    .inputs-section {
      flex: 1;
      min-width: 300px;
      display: flex;
      flex-direction: column;
      gap: 18px;
    }

    .section-title {
      font-size: 12px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: #4f46e5;
      margin-top: 4px;
      margin-bottom: -2px;
    }

    .form-row {
      display: flex;
      gap: 16px;
      flex-wrap: wrap;
    }

    .two-cols > * {
      flex: 1;
      min-width: 220px;
    }

    .input-group label {
      display: block;
      font-size: 11px;
      font-weight: 800;
      color: #64748b;
      text-transform: uppercase;
      margin-bottom: 8px;
      letter-spacing: 0.8px;
    }

    .input-group input,
    .input-group select {
      width: 100%;
      padding: 14px 18px;
      border: 1.5px solid #e2e8f0;
      border-radius: 12px;
      font-size: 14px;
      color: #0f172a;
      font-family: inherit;
      font-weight: 600;
      transition: 0.2s;
      background: #fbfcfd;
    }

    .input-group input:focus,
    .input-group select:focus {
      outline: none;
      border-color: #4f46e5;
      background: #fff;
      box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
    }

    .custom-select {
      appearance: none;
    }

    .switch-block {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }

    .switch-row-inline {
      min-height: 50px;
      display: flex;
      align-items: center;
      gap: 10px;
      border: 1.5px solid #e2e8f0;
      border-radius: 12px;
      padding: 0 16px;
      background: #fbfcfd;
      font-weight: 700;
      color: #334155;
    }

    .switch-row-inline input {
      width: auto;
      margin: 0;
    }

    .color-input-wrap {
      display: flex;
      gap: 10px;
      align-items: center;
    }

    .color-picker {
      width: 56px !important;
      min-width: 56px;
      height: 50px;
      padding: 4px !important;
      border-radius: 12px;
      cursor: pointer;
      background: #fff !important;
    }

    .fiscal-box {
      background: #f8fafc;
      padding: 24px;
      border-radius: 16px;
      border: 1px solid #e2e8f0;
      margin-top: 10px;
    }

    .fiscal-head {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 14px;
    }

    .fiscal-head label {
      margin: 0;
      color: #4f46e5;
      font-size: 12px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: .8px;
    }

    .dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #4f46e5;
    }

    .mono-input {
      font-family: monospace !important;
      font-size: 13px !important;
    }

    .helper-text {
      font-size: 11px;
      color: #94a3b8;
      margin: 8px 0 0 0;
      font-weight: 500;
    }

    .form-actions {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      gap: 16px;
      margin-top: 24px;
      border-top: 1px solid #f1f5f9;
      padding-top: 28px;
    }

    .cancel-btn {
      background: #f1f5f9;
      color: #64748b;
      border: none;
      padding: 14px 28px;
      border-radius: 12px;
      font-weight: 700;
      cursor: pointer;
      transition: 0.2s;
    }

    .cancel-btn:hover {
      background: #e2e8f0;
      color: #0f172a;
    }

    .save-btn {
      background: #10b981;
      color: #fff;
      border: none;
      padding: 14px 32px;
      border-radius: 12px;
      font-weight: 700;
      cursor: pointer;
      transition: 0.3s;
      display: flex;
      align-items: center;
      gap: 8px;
      box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.2);
    }

    .save-btn:hover {
      background: #059669;
      transform: translateY(-2px);
      box-shadow: 0 15px 20px -3px rgba(16, 185, 129, 0.3);
    }

    .save-btn:disabled {
      opacity: 0.7;
      cursor: wait;
      transform: none;
    }

    .empresas-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
      gap: 24px;
    }

    .empresa-card {
      background: #fff;
      border-radius: 24px;
      padding: 28px;
      border: 1px solid #e2e8f0;
      display: flex;
      gap: 20px;
      align-items: flex-start;
      position: relative;
      transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
    }

    .empresa-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 20px 25px -5px rgba(0,0,0,0.08);
      border-color: #4f46e5;
    }

    .card-actions {
      position: absolute;
      top: 20px;
      right: 20px;
      display: flex;
      gap: 8px;
      opacity: 0;
      transition: 0.2s;
    }

    .empresa-card:hover .card-actions {
      opacity: 1;
    }

    .action-btn {
      width: 32px;
      height: 32px;
      border-radius: 10px;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 0.2s;
    }

    .action-btn.edit {
      background: #eef2ff;
      color: #4f46e5;
    }

    .action-btn.edit:hover {
      background: #4f46e5;
      color: #fff;
    }

    .action-btn.delete {
      background: #fef2f2;
      color: #ef4444;
    }

    .action-btn.delete:hover {
      background: #ef4444;
      color: #fff;
    }

    .empresa-logo {
      width: 76px;
      height: 76px;
      border-radius: 18px;
      background: #f8fafc;
      color: #cbd5e1;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      flex-shrink: 0;
      border: 2px solid #f1f5f9;
    }

    .empresa-logo img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .empresa-info {
      flex: 1;
      min-width: 0;
    }

    .card-topline {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 10px;
      margin-bottom: 10px;
    }

    .empresa-info h3 {
      margin: 0;
      font-size: 17px;
      font-weight: 800;
      color: #0f172a;
      line-height: 1.2;
    }

    .badge-status {
      display: inline-flex;
      white-space: nowrap;
      padding: 5px 10px;
      border-radius: 999px;
      font-size: 10px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: .5px;
      background: #e2e8f0;
      color: #475569;
    }

    .badge-status.off {
      background: #f1f5f9;
      color: #64748b;
    }

    .info-row {
      font-size: 13px;
      color: #64748b;
      margin-bottom: 6px;
      font-weight: 500;
      word-break: break-word;
    }

    .info-row strong {
      color: #475569;
      font-weight: 700;
      margin-right: 4px;
    }

    .icon-line {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .icon-line a {
      color: #4f46e5;
      text-decoration: none;
      font-weight: 700;
    }

    .icon-line a:hover {
      text-decoration: underline;
    }

    .badge-row {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-top: 12px;
    }

    .badge-fiscal,
    .badge-ambiente {
      display: inline-flex;
      padding: 5px 10px;
      border-radius: 8px;
      font-size: 10px;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .badge-fiscal.success {
      background: #dcfce7;
      color: #15803d;
    }

    .badge-fiscal.warning {
      background: #fff7ed;
      color: #c2410c;
    }

    .badge-ambiente {
      background: #eef2ff;
      color: #4338ca;
    }

    .loading-state {
      grid-column: 1/-1;
      text-align: center;
      padding: 100px;
      color: #4f46e5;
      font-weight: 700;
      font-size: 18px;
    }

    .empty-state {
      grid-column: 1/-1;
      text-align: center;
      padding: 80px 40px;
      background: #f8fafc;
      border: 2px dashed #e2e8f0;
      border-radius: 32px;
      color: #94a3b8;
    }

    .empty-state svg {
      width: 48px;
      height: 48px;
      margin-bottom: 16px;
      opacity: 0.5;
    }

    .empty-state p {
      font-size: 18px;
      font-weight: 800;
      color: #475569;
      margin: 0 0 8px 0;
    }

    .empty-state span {
      font-size: 14px;
      font-weight: 500;
      max-width: 320px;
      display: block;
      margin: 0 auto;
    }

    @keyframes slideUp {
      from { opacity: 0; transform: translateY(30px); }
      to { opacity: 1; transform: translateY(0); }
    }

    @media (max-width: 900px) {
      .form-card {
        padding: 24px;
      }

      .form-grid {
        flex-direction: column;
      }

      .logo-upload-section {
        width: 100%;
        margin-bottom: 6px;
      }

      .upload-box {
        margin: 0 auto;
      }

      .header {
        flex-direction: column;
        align-items: flex-start;
      }

      .primary-btn {
        width: 100%;
        justify-content: center;
      }

      .empresas-grid {
        grid-template-columns: 1fr;
      }

      .card-actions {
        opacity: 1;
      }
    }

    @media (max-width: 600px) {
      .empresas-container {
        padding: 24px 14px;
      }

      .page-title {
        font-size: 22px;
      }

      .page-subtitle {
        font-size: 14px;
      }

      .header-left {
        align-items: flex-start;
      }

      .empresa-card {
        padding: 20px;
        gap: 14px;
      }

      .empresa-logo {
        width: 62px;
        height: 62px;
      }

      .form-actions {
        flex-direction: column;
      }

      .cancel-btn,
      .save-btn {
        width: 100%;
        justify-content: center;
      }

      .card-topline {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  `}</style>
);